/* eslint-disable */
import { useStore } from "vuex";
import { computed } from "vue";

const initialLetters = () => {
  const store = useStore();

  const owner: any = store.getters.currentUser.name || '';
  const email: string = store.getters.currentUser.email || '';
  const plan: string = store.getters?.currentUser?.plan?.name || '';
  const planId: any = store.getters?.currentUser?.plan?._id || '';
  const createdAt: any = store.getters?.currentUser?.createdAt || '';
  
  const initials = computed(() =>
    owner
      .match(/(^\S\S?|\b\S)?/g)
      .join("")
      .match(/(^\S|\S$)?/g)
      .join("")
      .toUpperCase()
  );
  const planComp = computed(()=> {
    return store.getters?.currentUser?.plan?.name || '';
  })

  

  return {
    owner,
    email,
    plan,
    initials,
    planComp,
    planId,
    createdAt

  };
};

export default initialLetters;
